import { delay } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PenaltyUpdateService {

  constructor(private httpClient: HttpClient) {
  }

  updatePenalty(penalty, id) {
    return this.httpClient.put(
      `${environment.API_ENDPOINT}penalties/${id}`,
      JSON.stringify(penalty))
      .pipe(delay(environment.RESPONSE_DELAY));
  }
}
